export const siteConfig = {
  siteName: import.meta.env.VITE_SITE_NAME || '物流集货平台',
  siteDescription: import.meta.env.VITE_SITE_DESCRIPTION || '专业跨境物流一站式服务平台，整合空运、海运、快递多渠道资源',
  contactPhone: import.meta.env.VITE_CONTACT_PHONE || '400-XXX-XXXX',
  servicePhone: import.meta.env.VITE_SERVICE_PHONE || '400-XXX-XXXX',
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL || 'xx@xx.com',
  contactAddress: import.meta.env.VITE_CONTACT_ADDRESS || '中国XXXXXX',
  socialWechat: import.meta.env.VITE_SOCIAL_WECHAT || '#',
  socialWeibo: import.meta.env.VITE_SOCIAL_WEIBO || '#',
  socialFacebook: import.meta.env.VITE_SOCIAL_FACEBOOK || '#',
  socialTwitter: import.meta.env.VITE_SOCIAL_TWITTER || '#',
  companyName: import.meta.env.VITE_COMPANY_NAME || '物流集货平台',
  companyIcp: import.meta.env.VITE_COMPANY_ICP || '',
}
